var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("SidebarWidget", {
    attrs: {
      title: _vm.$gettext("Suche"),
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function fn() {
          return [
            _c(
              "form",
              {
                staticClass: "sidebar-search",
                on: {
                  submit: function submit($event) {
                    $event.preventDefault()
                    return _vm.onSearch.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "ul",
                  {
                    staticClass: "needles",
                  },
                  [
                    _c("li", [
                      _c(
                        "div",
                        {
                          staticClass: "input-group files-search",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchTerm,
                                expression: "searchTerm",
                              },
                            ],
                            attrs: {
                              id: "stock-images-search-widget-search",
                              type: "text",
                              "aria-label": _vm.$gettext(
                                "Geben Sie einen Suchbegriff mit mindestens 3 Zeichen ein."
                              ),
                            },
                            domProps: {
                              value: _vm.searchTerm,
                            },
                            on: {
                              input: function input($event) {
                                if ($event.target.composing) return
                                _vm.searchTerm = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.showSearchResults
                            ? _c(
                                "button",
                                {
                                  staticClass: "reset-search",
                                  attrs: {
                                    title: _vm.$gettext(
                                      "Suchformular zurücksetzen"
                                    ),
                                  },
                                  on: {
                                    click: function click($event) {
                                      $event.preventDefault()
                                      return _vm.onReset.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("studip-icon", {
                                    attrs: {
                                      shape: "decline",
                                      size: 20,
                                      role: "presentation",
                                      alt: "",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "submit-search",
                              attrs: {
                                type: "submit",
                                value: _vm.$gettext("Suchen"),
                                "aria-controls":
                                  "stock-images-search-widget-search",
                                title: _vm.$gettext("Suche starten"),
                              },
                            },
                            [
                              _c("studip-icon", {
                                attrs: {
                                  shape: "search",
                                  size: 20,
                                  role: "presentation",
                                  alt: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }